define('vspot-angular/resources/paypal-resource',[], function () {
    'use strict';

    return ['$resource', function ($resource) {
        // See user-resource for general documentation
        return $resource('paypal/:controller:id',
            {
                id: '@id',
                controller: '@controller'
            },
            {

                goAccountRegisterURL: {
                    method: 'GET',
                    params: {
                        controller: 'go_account_register_url'
                    }
                },
                onboardingComplete: {
                    method: 'POST',
                    params: {
                        controller: 'onboarding_complete'
                    }
                },
                getReferralInfo: {
                    method: 'GET',
                    params: {
                        controller: 'get_referral_info'
                    }
                }
            }
        );
    }];
});


